import React from 'react';

// Code for footer section
const Footer = () => {
    return (
        <div>
            <p>Copyright &copy; 2021 Avishek Devnath</p>
        </div>
    );
};

export default Footer;